import React from "react";
import { useSprings, animated } from "react-spring";
import collectionStore from "../stores/collectionStore";
import MainStore from "../stores/MainStore";

const MoodModal = ({ changeMood }) => {
  const { closeModal } = MainStore();

  const moods = [
    { image: "icons/icon_productive.png", mood: "productive" },
    { image: "icons/icon_happy.png", mood: "happy" },
    { image: "icons/icon_exhausted.png", mood: "exhausted" },
    { image: "icons/icon_angry.png", mood: "angry" },
    { image: "icons/icon_confused.png", mood: "confused" },
    { image: "icons/icon_sad.png", mood: "sad" },
    { image: "icons/icon_question.png", mood: "unknown" },
  ];
  const [springs, api] = useSprings(
    moods.length,
    () => ({
      from: { opacity: 0 },
      to: { opacity: 1 },
    }),
    []
  );
  return (
    <div className="divRow">
      {springs.map((props, index) => {
        return (
          <animated.img
            key={index}
            style={props}
            src={moods[index].image}
            className="icon40"
            onClick={() => {
              changeMood(moods[index].mood);
              closeModal();
            }}
          />
        );
      })}
    </div>
  );
};

export default MoodModal;
